import { capacityTone } from '@/lib/capacity';

interface CapacityBarProps {
  label: string;
  allocated: number;
  available: number;
  percent: number;
  unit: string;
  format?: (n: number) => string;
}

const TONE_CLASS = {
  ok: 'bg-primary',
  warning: 'bg-status-warning',
  danger: 'bg-status-danger',
} as const;

export function CapacityBar({ label, allocated, available, percent, unit, format }: CapacityBarProps) {
  const fmt = format ?? ((n: number) => n.toLocaleString());
  const width = Number.isFinite(percent) ? Math.max(0, Math.min(percent, 100)) : 0;
  const text = `${fmt(allocated)} / ${fmt(available)} ${unit} (${percent}%)`;
  const barColor = TONE_CLASS[capacityTone(percent)];
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium">{label}</span>
        <span className="text-muted-foreground tabular-nums">
          {text}
        </span>
      </div>
      <div
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={width}
        aria-valuetext={text}
        aria-label={`${label} usage`}
        className="h-2 w-full overflow-hidden rounded-full bg-muted"
      >
        <div className={`h-full ${barColor}`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
